@if (isAuthenticated$ | async) {
  <ul class="navbar-nav">
    <li class="nav-item" ngbDropdown display="dynamic" placement="bottom-end">
      <button
        type="button"
        class="btn nav-link text-white appearance-toggle"
        ngbDropdownToggle
        i18n-aria-label
        aria-label="Appearance"
        [title]="title()"
      >
        <i class="fa fa-adjust"></i>
      </button>
      <div ngbDropdownMenu class="dropdown-menu">
        <h6 class="dropdown-header" i18n>Appearance</h6>
        @for (option of options; track option.mode) {
          <button
            ngbDropdownItem
            type="button"
            class="dropdown-item d-flex align-items-center"
            [class.active]="themeService.mode() === option.mode"
            (click)="setAppearance(option.mode)"
          >
            <i class="fa {{ option.iconClass }} me-2"></i>
            {{ option.label }}
            @if (themeService.mode() === option.mode) {
              <i class="fa fa-check ms-auto ps-2"></i>
            }
          </button>
        }
      </div>
    </li>
  </ul>
}
